<template>
  <Authenticated>
    <Confirm :open="showAddCategory" message="Category Name:" :isCreateConfirm="true" subMsg="This will be the name of your category" @confirm-modal="create" @close="showAddCategory = false" />
    <div>
      <button @click="showAddCategory = !showAddCategory" class="action-buttons action-colour"><font-awesome-icon icon="plus" /> Add Category</button>

      <div class="actions">
        <h2>Product Categories</h2>
        <ToggleSwitch onLabel="Edit" offLabel="Re Order" :modelValue="reOrder" modelName="reOrder" @update:modelValue="updateReOrder" />
      </div>
      <ul v-if="!reOrder" class="table wrapper layout content-gap">
        <router-link :to="'/products/' + category.value._id.replace(/^.*:/, '')" v-bind:key="category" v-for="category in categories" class="modifierBox">
          <li>
            <div class="box">
              <p style="text-align: center">
                <span class="modifier-name">{{ category.value.name }}</span>
                <span class="modifier-price">{{ category.value.products.length }} products</span>
              </p>
            </div>
          </li>
        </router-link>
      </ul>
    </div>
    <div v-if="reOrder">
      <draggable :list="orderedCats" @start="drag = true" @end="checkMove" tag="ul" class="table layout wrapper content-gap" item-key="element">
        <template #item="{ element }">
          <li class="modifierBox">
            <div class="box">
              <p style="text-align: center">
                <span class="modifier-name">{{ element.value.name }}</span>
                <span class="modifier-price">{{ element.value.products.length }} products</span>
              </p>
            </div>
          </li>
        </template>
      </draggable>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated";
import { Confirm, ToggleSwitch } from "@monolith/components";
import { mapGetters } from "vuex";
import Slug from "slug";
import draggable from "vuedraggable";

export default {
  name: "Modifiers",
  components: {
    Authenticated,
    Confirm,
    draggable,
    ToggleSwitch,
  },

  data() {
    return {
      currentSet: null,
      currentModifier: null,
      currentDrag: null,
      currentDragOverCategory: null,
      showAddCategory: false,
      tableMode: false,
      orderedCats: [],
      reOrder: false,
    };
  },
  async mounted() {
    this.$store.commit("currPage", "products");
    await this.$store.dispatch("getCategories");
    this.orderedCats = this.categories.map((cat) => cat);
  },

  methods: {
    updateReOrder(value) {
      this.reOrder = value;
    },
    async checkMove() {
      let catArray = [];
      this.orderedCats.forEach((cat) => {
        catArray.push(cat.id.split(":")[1]);
      });
      let doc = {
        _id: "categories",
        categories: catArray,
      };
      this.channel.push("categories:update", doc);
      this.$store.dispatch("getCategories");
    },

    async create(category) {
      let cat = {
        _id: "category:" + Slug(category),
        name: category,
        description: "",
        posOnly: false,
        products: [],
      };
      await this.channel.push("document:new", cat);
    },
    go(id) {
      this.$router.push("/modifiers/" + id.replace(/^.*:/, ""));
    },
    hasModifiers(currentSet) {
      return currentSet.value && currentSet.value.modifiers && currentSet.value.modifiers.length;
    },
  },

  computed: {
    ...mapGetters({
      categories: "categories",
    }),

    // cats() {
    //   return this.categories.map((cat) => cat);
    // },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
.add-product {
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 10rem;
}
.toggle{
  margin-left: 0;
}

@media only screen and (orientation: portrait) {
  .actions{
    h2{
      min-width: 14rem !important;
    }
  }
}
</style>
